module.exports = __webpack_public_path__ + "img/NZA Annex P - Forest carbon sink.pdf";